import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import ArrowLeft from '@material-ui/icons/NavigateBefore';
import ArrowRight from '@material-ui/icons/NavigateNext';
import Fade from '@material-ui/core/Fade';
import ComponentOnSite from './ComponentOnSite';
import ComponentTop from './ComponentTop';

var pipe = function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (v) {
    return fns.reduce(function (r, fn) {
      return fn(r);
    }, v);
  };
};

var useStyles = makeStyles(function () {
  return (
    /* theme */
    {
      root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%'
      }
    }
  );
}, {
  name: 'SxComProductImgListCarousel'
});

var _ref = /*#__PURE__*/React.createElement(ArrowLeft, null);

var LeftIcon = function LeftIcon() {
  return _ref;
};

var _ref2 = /*#__PURE__*/React.createElement(ArrowRight, null);

var RightIcon = function RightIcon() {
  return _ref2;
};

var ProductImgListCarousel = /*#__PURE__*/React.forwardRef(function ProductImgListCarousel(_ref3, ref) {
  var autoSlide = _ref3.autoSlide,
      autoSlideInterval = _ref3.autoSlideInterval,
      children = _ref3.children,
      pClasses = _ref3.classes,
      className = _ref3.className,
      Component = _ref3.Component,
      ComponentProps = _ref3.ComponentProps,
      _ref3$IconLeftCompone = _ref3.IconLeftComponent,
      IconLeftComponent = _ref3$IconLeftCompone === void 0 ? LeftIcon : _ref3$IconLeftCompone,
      _ref3$IconRightCompon = _ref3.IconRightComponent,
      IconRightComponent = _ref3$IconRightCompon === void 0 ? RightIcon : _ref3$IconRightCompon,
      showNum = _ref3.showNum,
      title = _ref3.title,
      TitleProps = _ref3.TitleProps,
      _ref3$TransitionCompo = _ref3.TransitionComponent,
      TransitionComponent = _ref3$TransitionCompo === void 0 ? Fade : _ref3$TransitionCompo,
      TransitionProps = _ref3.TransitionProps,
      variant = _ref3.variant,
      rest = _objectWithoutProperties(_ref3, ["autoSlide", "autoSlideInterval", "children", "classes", "className", "Component", "ComponentProps", "IconLeftComponent", "IconRightComponent", "showNum", "title", "TitleProps", "TransitionComponent", "TransitionProps", "variant"]);

  var cntRef = React.useRef(); // const tmRef = React.useRef();

  var _React$useMemo = React.useMemo(function () {
    var rfs = React.Children.map(children, function () {
      return /*#__PURE__*/React.createRef();
    });
    return [rfs, React.Children.map(children, function (ch, idx) {
      return /*#__PURE__*/React.cloneElement(ch, {
        ref: rfs[idx]
      });
    }), React.Children.count(children)];
  }, [children]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 3),
      chRefs = _React$useMemo2[0],
      nextChildren = _React$useMemo2[1],
      childrenCount = _React$useMemo2[2];

  var classes = useStyles({
    classes: pClasses
  });

  var _React$useState = React.useState({
    disp: 0,
    disabledLeft: true,
    disabledRight: childrenCount <= showNum
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      _React$useState2$ = _React$useState2[0],
      disabledLeft = _React$useState2$.disabledLeft,
      disabledRight = _React$useState2$.disabledRight,
      disp = _React$useState2$.disp,
      setDisp = _React$useState2[1];

  var move = React.useCallback(function (pDisp, dir) {
    var cntWidth = cntRef.current.offsetWidth;
    var maxLeft = cntRef.current.scrollWidth - cntWidth;
    var nextDisp = pipe(function (d) {
      return d < 0 ? 0 : d;
    }, function (d) {
      return d >= childrenCount ? childrenCount - 1 : d;
    })(pDisp + dir);
    var delta = chRefs[nextDisp].current.offsetWidth * dir;
    var left = pipe(function (l) {
      return l < 0 ? 0 : l;
    }, function (l) {
      return l >= maxLeft ? maxLeft : l;
    })(cntRef.current.scrollLeft + delta);
    var dl = {
      disabledLeft: left === 0
    };
    var dr = {
      disabledRight: left === maxLeft
    };
    cntRef.current.scroll({
      left: left,
      top: 0,
      behavior: 'smooth'
    });
    setDisp(function (pd) {
      return _extends({}, pd, {
        disp: nextDisp
      }, dl, dr);
    });
  }, [chRefs, childrenCount]);
  var handleMove = React.useCallback(function (dir) {
    return function () {
      return move(disp, dir);
    };
  }, [disp, move]);
  React.useEffect(function () {
    if (autoSlide) {
      var timer = setTimeout(function () {
        return disp !== childrenCount - 1 ? handleMove(1)() : move(disp, -disp);
      }, autoSlideInterval);
      return function () {
        return clearTimeout(timer);
      };
    }

    return undefined;
  });
  var ScrollComponent = React.useMemo(function () {
    if (Component) return Component;
    if (variant === 'on-site') return ComponentOnSite;
    if (variant === 'top') return ComponentTop;
    return null;
  }, [Component, variant]);
  var handleActiveChange = React.useCallback(function (ind) {
    if (ind === 0) {
      return move(disp, -disp);
    }

    if (ind > disp) {
      return move(disp, ind);
    }

    if (ind < disp) {
      return move(disp, -ind);
    }

    return null;
  }, [disp, move]);
  return /*#__PURE__*/React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className),
    ref: ref
  }), /*#__PURE__*/React.createElement(ScrollComponent, _extends({
    ref: cntRef,
    active: disp,
    handleMove: handleMove,
    disabledLeft: disabledLeft,
    disabledRight: disabledRight,
    autoSlide: autoSlide,
    title: title,
    TitleProps: TitleProps,
    TransitionComponent: TransitionComponent,
    TransitionProps: TransitionProps,
    IconLeftComponent: IconLeftComponent,
    IconRightComponent: IconRightComponent,
    hideArrows: variant === 'none',
    showNum: showNum,
    onActiveChange: handleActiveChange
  }, ComponentProps), nextChildren));
});
ProductImgListCarousel.propTypes = {
  autoSlide: PropTypes.bool,
  autoSlideInterval: PropTypes.number,
  children: PropTypes.node,
  classes: PropTypes.shape({
    arrows: PropTypes.string,
    container: PropTypes.string,
    content: PropTypes.string,
    headline: PropTypes.string,
    root: PropTypes.string,
    title: PropTypes.string
  }),
  className: PropTypes.string,
  Component: PropTypes.elementType,
  ComponentProps: PropTypes.shape({}),
  IconLeftComponent: PropTypes.elementType,
  IconRightComponent: PropTypes.elementType,
  showNum: PropTypes.number,
  title: PropTypes.elementType,
  TitleProps: PropTypes.shape({}),
  TransitionComponent: PropTypes.elementType,
  TransitionProps: PropTypes.shape({}),
  variant: PropTypes.oneOfType(['top', 'on-site', 'none'])
};
ProductImgListCarousel.defaultProps = {
  autoSlide: false,
  autoSlideInterval: 2000,
  children: null,
  classes: undefined,
  className: undefined,
  Component: undefined,
  ComponentProps: undefined,
  IconLeftComponent: undefined,
  IconRightComponent: undefined,
  showNum: 4,
  title: undefined,
  TitleProps: undefined,
  TransitionComponent: undefined,
  TransitionProps: undefined,
  variant: 'top'
};
export default ProductImgListCarousel;